import { Avatar, Box, Stack, Typography } from "@mui/material";
import React from "react";
import { CURRENCY } from "../../lib/variables";
import { useSelector } from "react-redux";

const useStyle = {
  avatar: {
    height: { xs: 50, md: 80 },
    width: { xs: 50, md: 80 },
    borderRadius: 2,
    border: "1px solid #c5c5c5",
    "& .MuiAvatar-img": {
      objectFit: "contain",
    },
  },
};

const ReviewCartCard = ({ cartData }) => {
  const isDiscount = cartData.discount > 0 ? true : false;
  const productPrice =
    cartData.discount > 0 ? cartData.discount : cartData.price;
  const { currentLanguage } = useSelector((state) => state.translationReducer);


  return (
    <Stack gap={2} direction={"row"} alignItems={"center"} overflow={"hidden"}>
      <Avatar src={cartData?.coverImage} sx={{ ...useStyle.avatar }} />
      <Stack overflow={"hidden"}>
        <Typography noWrap>{cartData.name[currentLanguage]}</Typography>
        <Stack direction={"row"} alignItems={"center"} gap={2}>
          <Typography variant="body2" color="text.coolGrey">
            x{cartData.selectedQty}
          </Typography>
          {/* only shows size and color and weight */}

          {cartData?.type === "Package" && (
            <Box
              px={1}
              width={"auto"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              borderRadius={1}
              sx={{
                background: "linear-gradient(45deg, #FF007F, #FF9E00)",
              }}
            >
              <Typography fontSize={"0.75rem"} color={"text.white"}>
                Package
              </Typography>
            </Box>
          )}
          {cartData?.selectedColor && (
            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant="body2">color :</Typography>
              <Box
                height={15}
                width={15}
                bgcolor={cartData?.selectedColor?.color}
                borderRadius={"100%"}
              ></Box>
            </Stack>
          )}
          {cartData?.selectedSize && (
            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant="body2">Size :</Typography>
              <Box
                px={1}
                height={20}
                width={"auto"}
                border={"1px solid"}
                borderColor={"text.borderGrey"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                borderRadius={1}
                fontSize={"0.875rem"}
              >
                {cartData?.selectedSize?.name}
              </Box>
            </Stack>
          )}
          {cartData?.selectedWeight && (
            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant="body2">Weight :</Typography>
              <Box
                px={1}
                height={20}
                width={"auto"}
                border={"1px solid"}
                borderColor={"text.borderGrey"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                borderRadius={1}
                fontSize={"0.875rem"}
              >
                {cartData?.selectedWeight?.name}
              </Box>
            </Stack>
          )}
          {cartData?.selectedSizeWithColor && (
            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant="body2">size :</Typography>

              <Box
                height={20}
                width={20}
                border={"1px solid"}
                borderColor={"text.borderGrey"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                borderRadius={1}
                fontSize={"0.875rem"}
              >
                {cartData?.selectedSizeWithColor?.size}
              </Box>
              <Typography variant="body2" ml={2}>
                color :
              </Typography>

              <Box
                height={15}
                width={15}
                bgcolor={cartData?.selectedSizeWithColor?.color}
                borderRadius={"100%"}
              ></Box>
            </Stack>
          )}
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography color="primary.main">{`${CURRENCY} ${productPrice}`}</Typography>
          {isDiscount && (
            <Typography
              variant="body2"
              color="text.coolGrey"
              sx={{ textDecoration: "line-through" }}
            >
              {`${CURRENCY} ${cartData.price}`}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ReviewCartCard;
